/**
 * This custom hook provides a flexible functionality to sign-in via a social auth provider.
 * The caller only has to provide the provider as argument and this hook will take care about
 * the login via popup as well as the initialization of the roles (if not yet set).
 */

import {useState} from "react";
import {useIntl} from "react-intl";
import {useSnackbar} from "notistack";
import {useHistory} from "react-router-dom";

const useInitPassword = () => {
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    const history = useHistory();

    const [loading, setLoading] = useState(false)

    const initPassword = async (token, email, password) => {
        setLoading(true)

        return fetch('/reg-main/initPassword', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                token: token,
                password: password
            })
        }).then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            // Show info about success
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.users.messages.initPassword.success',
                    defaultMessage: 'Password successfully set - Login with {email} and your new password.'
                }, {email: email}), {
                    variant: 'success',
                    preventDuplicate: true,
                    autoHideDuration: 3000
                });

            // Redirect to sign-in page in case of success
            history.push("/")

        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.users.messages.initPassword.error',
                    defaultMessage: 'Something went wrong while setting your password: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        }).finally(() => {
            setLoading(false)
        })
    }

    return {initPassword, loading}
}
export default useInitPassword;